import mdc from './index-node'
import Chart from 'chart.js'

mdc.init = (markdown) => {
  let result = mdc.render(markdown)
  if (!document.getElementById('article-content')) {
    return
  }
  document.getElementById('article-content').innerHTML = result

  // charts
  document.querySelectorAll('#article-content .chartjs').forEach(element => {
    try {
      // `element` is the element you want to wrap
      const parent = element.parentNode
      const wrapper = document.createElement('div')
      wrapper.style.height = '400px'
      // set the wrapper as child (instead of the element)
      parent.replaceChild(wrapper, element)
      // set element as child of wrapper
      wrapper.appendChild(element)
      new Chart(element, JSON.parse(element.textContent)) // eslint-disable-line no-new
    } catch (e) {
      element.outerHTML = `<pre>Chart.js complains: "${e}"</pre>`
    }
  })

  return result
}

export default mdc
